import { Breadcrumbs, Typography, Link, Stack, TablePagination, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from "@mui/material";
import { useFolhaPagamentoListaViewModel } from "../../viewModels/folha_pagamento_lista_view_model";
import { Header } from "./components/header";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { useMemo } from "react";
import { GenerateFolhaPagamentoColumnsDef } from "./columns";
import { FolhaPagamento } from "../../../domain/models/folha_pagamento";
import { CadastroFolhaPagamentoModal } from "./components/cadastro_folha_pagamento_modal";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";
import { CopiaFolhaPagamentoModal } from "./components/copia_folha_pagamento_modal";
import { ReportFolhaPagamentoModal } from "./components/report_folha_pagamento_modal";
import { ReportFolhaPagamentoDetalhadaModal } from "./components/report_folha_pagamento_detalhada_modal";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal";

import DynamicIcon from "../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../common/components/primary_button";
import RefreshButton from "../../../../../common/components/refresh_button";
import AlertError from "../../../../../common/components/alert_error";
import DeleteDialog from "../../../../../common/components/delete_dialog";

/**
 * FolhaPagamentoLista
 */

export const FolhaPagamentoLista = () => {
  const viewModel = useFolhaPagamentoListaViewModel();

  const columnsDef = useMemo(() => {
    return GenerateFolhaPagamentoColumnsDef({
      onActionViewItem: viewModel.handleViewFolhaPagamento,
      onActionEdit: viewModel.handleOpenFolhaPagamentoModalOpenState,
      onActionDelete: viewModel.handleOpenDeleteFolhaPagamentoModal,
      onActionCopy: viewModel.handleOpenCopiaFolhaPagamentoModalOpenState,
    });
  }, [
    viewModel.handleViewFolhaPagamento,
    viewModel.handleOpenFolhaPagamentoModalOpenState,
    viewModel.handleOpenDeleteFolhaPagamentoModal,
    viewModel.handleOpenCopiaFolhaPagamentoModalOpenState,
  ]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[12rem]">
                <PrimaryButton
                  ref={viewModel.menuRef}
                  id="composition-button"
                  aria-controls={viewModel.openMenu ? 'composition-menu' : undefined}
                  aria-expanded={viewModel.openMenu ? 'true' : undefined}
                  aria-haspopup="true"
                  onClick={() => viewModel.handleToggleMenu(true)}
                  buttonColor="yellow">
                  Relatórios
                </PrimaryButton>
                <Popper
                  style={{ zIndex: 10000 }}
                  open={viewModel.openMenu}
                  anchorEl={viewModel.menuRef.current}
                  role={undefined}
                  placement="bottom-start"
                  transition
                  disablePortal
                >
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      style={{
                        transformOrigin:
                          placement === 'bottom-start' ? 'left top' : 'left bottom',
                      }}
                    >
                      <Paper>
                        <ClickAwayListener onClickAway={() => viewModel.handleToggleMenu(false)}>
                          <MenuList
                            autoFocusItem={viewModel.openMenu}
                            id="composition-menu"
                            aria-labelledby="composition-button"
                            onKeyDown={viewModel.handleListKeyDown}>
                            <MenuItem onClick={() => viewModel.handleReportFolhaPagamentoOpenState(true)}>Folha de Pagamento</MenuItem>
                            <MenuItem onClick={() => viewModel.handleReportFolhaPagamentoDetalhadaOpenState(true)}>Folha de Pagamento Detalhada</MenuItem>
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </div>
              <div className="w-[200px] ">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                  onClick={() => viewModel.handleOpenFolhaPagamentoModalOpenState(null, true)}>
                  Novo Item
                </PrimaryButton>
              </div>
            </div>
          }
        />
      </PageTopBar>

      {/**
        * Page
        */}

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            RH
          </Link>
          <Typography className="text-primary-green">
            Folha de Pagamento
          </Typography>
        </Breadcrumbs>

        <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
          <div className="flex gap-2 items-center w-full">
            <h1 className="text-3xl font-medium text-black dark:text-white">Folha de Pagamento</h1>
            <RefreshButton onClick={viewModel.handleReload} />
          </div>

          <div className="w-full justify-end flex gap-2">

          </div>
        </div>

        {
          viewModel.errorMessage !== undefined
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReload} />
              </div>
            ) : (
              <>
                <Header
                  tipoPesquisa={viewModel.filters.tipoPesquisa}
                  valorPesquisa={viewModel.filters.valorPesquisa}
                  dataCadastro={viewModel.filters.dataCadastro}
                  dataPagamento={viewModel.filters.dataPagamento}
                  numero={viewModel.filters.numero}
                  idFuncionario={viewModel.filters.idFuncionario}
                  funcionarios={viewModel.filters.funcionarios ?? []}
                  onTipoPesquisaChange={viewModel.handleTipoPesquisaChange}
                  onValorPesquisaChange={viewModel.handleValorPesquisaChange}
                  onFuncionarioChange={viewModel.handleFuncionarioChange}
                  onDataCadastroChange={viewModel.handleDataCadastroChange}
                  onDataPagamentoChange={viewModel.handleDataPagamentoChange}
                  onNumeroChange={viewModel.handleNumeroChange}
                  onClear={viewModel.handleClear}
                />

                <Stack spacing={0}>
                  <div className="w-full flex flex-row justify-end items-stretch">
                    <div className="flex flex-col justify-between flex-1">
                      <TablePagination
                        component="div"
                        count={viewModel.pagination.totalItems}
                        page={viewModel.pagination.page - 1}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        onPageChange={(_, p) => viewModel.handlePageChange(p)}
                        rowsPerPage={viewModel.pagination.rowsPerPage}
                        onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                      />
                    </div>
                  </div>

                  <StyledDataGrid
                    tableName="folha_pagamento_lista"
                    disableColumnMenu={false}
                    getRowId={(row: FolhaPagamento) => row.idFolhaPagamento}
                    columns={columnsDef}
                    loading={viewModel.loading}
                    rows={viewModel.folhaPagamentos}
                    rowCount={viewModel.folhaPagamentos.length}
                    pageSizeOptions={[10, 25, 50, 100]}
                    paginationMode="server"
                    paginationModel={{
                      page: viewModel.pagination.page,
                      pageSize: viewModel.pagination.rowsPerPage,
                    }}
                  />

                  <TablePagination
                    component="div"
                    count={viewModel.pagination.totalItems}
                    page={viewModel.pagination.page - 1}
                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    rowsPerPage={viewModel.pagination.rowsPerPage > 0 ? viewModel.pagination.rowsPerPage : 25}
                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                  />
                </Stack>
              </>
            )
        }
      </div>

      <CadastroFolhaPagamentoModal
        open={viewModel.openCadastroFolhaPagamentoModal}
        saving={viewModel.saving}
        selectedFolhaPagamento={viewModel.selectedFolhaPagamento ?? null}
        hookForm={viewModel.hookForm}
        onClose={() => viewModel.handleOpenFolhaPagamentoModalOpenState(null, false)}
        onSubmit={viewModel.handleFolhaPagamentoSubmit}
        onOpenChangeHistory={viewModel.handleOpenChangeHistory}
      />

      <CopiaFolhaPagamentoModal
        open={viewModel.openCopiaFolhaPagamentoModal}
        saving={viewModel.saving}
        selectedFolhaPagamento={viewModel.selectedFolhaPagamento ?? null}
        hookForm={viewModel.hookFormCopia}
        onClose={() => viewModel.handleOpenCopiaFolhaPagamentoModalOpenState(null, false)}
        onSubmit={viewModel.handleCopiaFolhaPagamentoSubmit}
      />

      <ReportFolhaPagamentoModal
        open={viewModel.openReportFolhaPagamento}
        loading={viewModel.loading}
        savedColunas={viewModel.savedColunas}
        funcionarios={viewModel.filters.funcionarios ?? []}
        subcontas={viewModel.filters.subcontas ?? []}
        centroCustos={viewModel.filters.centroCustos ?? []}
        folhaPagamentos={viewModel.filters.folhaPagamentos ?? []}
        bancoPagamentos={viewModel.filters.bancoPagamentos ?? []}
        filtroFolhaPagamento={viewModel.filters.filtroFolhaPagamento ?? null}
        hookForm={viewModel.hookFormReportFolhaPagamento}
        onClose={() => viewModel.handleReportFolhaPagamentoOpenState(false)}
        onSubmit={viewModel.handleSubmitReportFolhaPagamento}
        onSaveColunas={viewModel.handleCreateFiltroFolhaPagamentoSubmit}
      />

      <ReportFolhaPagamentoDetalhadaModal
        open={viewModel.openReportFolhaPagamentoDetalhada}
        loading={viewModel.loading}
        funcionarios={viewModel.filters.funcionarios ?? []}
        folhaPagamentos={viewModel.filters.folhaPagamentoDetalhadas ?? []}
        centroCustos={viewModel.filters.centroCustos ?? []}
        cargos={viewModel.filters.cargos ?? []}
        onClose={() => viewModel.handleReportFolhaPagamentoDetalhadaOpenState(false)}
        onSubmit={viewModel.handleSubmitReportFolhaPagamentoDetalhada}
      />

      <DeleteDialog
        open={viewModel.openDeleteFolhaPagamentoModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleOpenDeleteFolhaPagamentoModal(null, false)}
        title={`Você realmente deseja excluir esta folha de pagamento?`}
        onDelete={() => viewModel.handleConfirmarDeletarFolhaPagamento()}
      />

      {/**
        * Modal historico de alterações.
        */}

      <ChangeHistoryModal
        changeHistoryHandler={viewModel.changeHistory} />

      <ReportViewerModal
        reportViewerState={viewModel.reportViewerState}
      />

    </>
  );
}